import React from 'react';
import styled from 'styled-components';
import { SVGIcon } from '@superops/super-icons';
import { Spinner } from '@superops/ui-design-system';

const SecondaryButtonWrapper = styled.div`
  background-color: var(--sops-rounded-secondary-button-bg);
  border-radius: 20px;
  color: var(--sops-rounded-secondary-button-text);
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  min-width: fit-content;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  padding: 8px 15px;
  width: ${(props) => (props.fullWidth ? '100%' : 'unset')};
  &:hover {
    background-color: ${(props) =>
      props.disabled
        ? '#f0f2fc'
        : 'var(--sops-rounded-secondary-button-hover-bg)'};
  }
  svg {
    color: #011fff;
  }
`;

const SecondaryButton = ({
  onClick,
  label,
  icon,
  disabled,
  loading,
  fullWidth = true
}) => {
  const handleClick = () => {
    if (disabled) return;
    if (onClick) onClick();
  };

  return (
    <SecondaryButtonWrapper
      className="fx actr"
      onClick={handleClick}
      disabled={disabled}
      fullWidth={fullWidth}
    >
      {loading ? (
        <Spinner size="small" />
      ) : (
        <>
          <span className="mr-10 fx actr jctr">
            <SVGIcon
              name={icon || 'Save'}
              color="var(--sops-rounded-secondary-button-text)"
            />
          </span>
          <span>{label || 'Save'}</span>
        </>
      )}
    </SecondaryButtonWrapper>
  );
};

export default SecondaryButton;
